import { calculateOrgPermissions } from '../../../../../backend/features/accounts/shared';
import { transformOrgColumnIntoDataObject } from '../../../../../backend/features/accounts/utils/transformOrgColumnIntoDataObject';
import { flatten } from '../../../../../backend/utils/FilterUtils';
import { filterAccountColumnsOrganizationsByPermission, getDefaultOrgRole } from '../../shared';
export function handleChangeOrganizationMemberRole({ appContext, secureBulkActionParams: { createdBy, data, isCancelled, updateProcessedCount }, row, accountStorage, actionOwner, processedIndex, }) {
    var _a, _b;
    const defaultOrgRole = getDefaultOrgRole(appContext.appState.settings.orgRoleMap);
    if (!defaultOrgRole) {
        throw new Error('No default organization role set. Please check settings orgRoleMap and set default role.');
    }
    const { organizationId, newRole } = data.params;
    const accountOrgStatuses = transformOrgColumnIntoDataObject(row.columns.orgStatus);
    const currentAccountOrgRoles = transformOrgColumnIntoDataObject(row.columns.orgRole);
    const ownerSystemPermissions = appContext.appState.settings.systemRoleMap[actionOwner.data.systemRole].permissions;
    const { orgRole: allowedToManageOrgRoles, orgStatus: allowedToManageOrgStatuses } = filterAccountColumnsOrganizationsByPermission(row.columns, row.id, ['manage-members'], {
        id: createdBy,
        orgPermissions: calculateOrgPermissions(appContext, actionOwner.data),
        systemPermissions: ownerSystemPermissions,
    });
    const currentOrgStatus = accountOrgStatuses[organizationId];
    const currentOrgRole = allowedToManageOrgRoles[organizationId];
    // Check if role is required for this orgStatus
    const mustHaveRole = !!((_b = (_a = appContext.appState.settings.orgStatusMap) === null || _a === void 0 ? void 0 : _a[currentOrgStatus]) === null || _b === void 0 ? void 0 : _b.requireOrgRole);
    const { updatedRoles, isDeleted } = handleRoleChanged({
        currentAccountOrgRoles,
        organizationId,
        mustHaveRole,
        secureFilter: data.secureParams.secureFilter,
        newRole,
        currentOrgRole,
        defaultOrgRole,
    });
    let updated = false;
    // Role can be empty but status is always defined thus checking membership on status
    if (allowedToManageOrgStatuses[organizationId] && updatedRoles) {
        accountStorage.post({
            action: 'partial-update',
            id: row.id,
            data: {
                orgRole: updatedRoles,
            },
            actionParams: {
                bulkAction: true,
            },
        });
        updated = true;
    }
    updateProcessedCount(processedIndex + 1);
    return { cancel: isCancelled(), deleted: isDeleted, updated };
}
function handleRoleChanged({ currentAccountOrgRoles, organizationId, secureFilter, mustHaveRole, newRole, currentOrgRole, defaultOrgRole, }) {
    let roles;
    if (mustHaveRole && newRole) {
        roles = Object.assign(Object.assign({}, currentAccountOrgRoles), { [organizationId]: newRole });
        // add default role if orgRole is required for orgStatus
    }
    else if (mustHaveRole && !currentOrgRole && defaultOrgRole) {
        roles = Object.assign(Object.assign({}, currentAccountOrgRoles), { [organizationId]: defaultOrgRole });
        // remove orgRole if status does not require to have one
    }
    else if (currentOrgRole && !mustHaveRole) {
        roles = Object.assign({}, currentAccountOrgRoles);
        delete roles[organizationId];
    }
    const flatFilter = flatten(secureFilter);
    const roleValues = new Set();
    for (const filter of flatFilter) {
        if ('column' in filter && filter.op === 'overlap' && 'value' in filter && filter.column === 'orgRole') {
            if (Array.isArray(filter.value)) {
                filter.value.forEach((value) => roleValues.add(value));
            }
        }
    }
    const isDeleted = currentOrgRole
        ? roleValues.has(`${organizationId}_${currentOrgRole}`) && !roleValues.has(`${organizationId}_${newRole !== null && newRole !== void 0 ? newRole : defaultOrgRole}`)
        : false;
    return { updatedRoles: roles, isDeleted };
}
